const Map = () => {

		
	return (
		<>
		<iframe style={{width : "100%" , height : "400px"}} src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=36.340741, 43.394870&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed" title="get in touch"></iframe>
		</>
	)
}

export default Map